import { render, staticRenderFns } from "./emailEdit.vue?vue&type=template&id=645c3b52&scoped=true&"
import script from "./emailEdit.vue?vue&type=script&lang=js&"
export * from "./emailEdit.vue?vue&type=script&lang=js&"
import style0 from "./emailEdit.vue?vue&type=style&index=0&id=645c3b52&prod&lang=scss&scoped=scoped&"
import style1 from "./emailEdit.vue?vue&type=style&index=1&id=645c3b52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645c3b52",
  null
  
)

export default component.exports